import { ActionTree } from 'vuex';
import { IRootState } from '../root-state.store';
import { ITenantState } from './tenant-state.store';
import { TENANT_GET_TENANTS, TENANT_SET_TENANTS, TENANT_GET_BLOCK_TENANTS, TENANT_SET_BLOCK_TENANTS, TENANT_GET_BLOCK_TENANT, TENANT_SET_BLOCK_TENANT, TENANT_LOADING, TENANT_GET_TENANT } from './tenant-types.store';
import { ActivityStatus, UserTypes } from '../../common/enums';

export const actions: ActionTree<ITenantState, IRootState> = {

  [TENANT_GET_TENANTS]: async ({ state, commit, rootGetters }, param: any) => {

    if (state.tenants !== null) return;
    else if (rootGetters['user/userInfo'].type === undefined || rootGetters['user/userInfo'].type === UserTypes.Tenant) {
      return Promise.reject('Permission denined');
    }


    return state.service.getTenantsForTicket(param)
      .then(tenants => {
        commit(TENANT_SET_TENANTS, {
          activityStatus: ActivityStatus.Loaded,
          tenants
        })
      })
      .catch(error => console.log(error));
  }
  , [TENANT_GET_TENANT]: async ({ state, commit, rootGetters }, id: string) => {

    return state.service.getTenantById(id)
      .then(tenant => {
        console.log(tenant,'tenant')
        return tenant;
      })
      .catch(error => console.log(error));
  }
  , [TENANT_GET_BLOCK_TENANTS]: async ({ state, commit, rootGetters }, payload: { blockId: string, param: any }) => {

    return state.service.getBlockTenants(payload.blockId, payload.param)
      .then(data => {
        commit(TENANT_SET_BLOCK_TENANTS, {
          activityStatus: ActivityStatus.Loaded,
          data
        })
        return data;
      })
      .catch(error => console.log(error));
  }
  , [TENANT_GET_BLOCK_TENANT]: async ({ state, commit, rootGetters }, payload: { blockId: string, tenantId: string }) => {

    commit(TENANT_LOADING, ActivityStatus.Loading);
    console.log(payload, 'tenant')
    return state.service.getBlockTenantById(payload.blockId, payload.tenantId)
      .then(tenant => {
        commit(TENANT_SET_BLOCK_TENANT, tenant)
        return tenant;
      })
      .catch(error => {
        commit(TENANT_LOADING, ActivityStatus.LoadFailed)
        return error;
      });
  }
}


// WEBPACK FOOTER //
// ./src/store/tenant/tenant-actions.store.ts